import { DescribeNodeType } from '~/scenes/Automation/Flows/Actions/util/descriptionStandards';

const describeAppVBOWaardecheckReportNewCondition = (): DescribeNodeType =>
  'een nieuwe Avix waardecheck is opgevraagd';

export default describeAppVBOWaardecheckReportNewCondition;
